import { Card, Form } from "react-bootstrap";
import CustomButton from "../../components/CustomButton/CustomButton";
import { useEffect, useState } from "react";
import WebService from "../../utility/WebService";
import { PencilFill, TrashFill } from "react-bootstrap-icons";
import DeleteModal from "../../components/DeleteModal/DeleteModal";
import CustomTableSortable from "../../components/CustomTable/CustomTableSortable";
import HelperService from "../../utility/HelperService";
import { toast } from "react-toastify";

export interface AddCommentInterface {
  _id: number;
  userName: string;
  userCompany: string;
  comment: string;
  location: string;
}

export enum AdminUserStatusEnum {
  ACTIVE = "ACTIVE",
  INACTIVE = "INACTIVE",
  DELETED = "DELETED",
}

const columns = [
  {
    id: "email",
    label: "Subscribers Email",
    minWidth: 170,
    sortable: true,
  },
  {
    id: "createdAt",
    label: "Created Date",
    minWidth: 170,
    sortable: true,
  }
];

const AdminUser = () => {
  const [showAdminBlade, setShowAdminBlade] = useState(false);
  const [leadershipCouncils, setLeadershipCouncils] = useState([]);
  const [showDeleteModal, setShowDeleteModal] = useState(false);
  const [leadershipCouncilToDelete, setLeadershipCouncilToDelete] = useState<
    string | null
  >(null);
  const [totalCount, setTotalCount] = useState(0);
  const [currentPage, setCurrentPage] = useState(1);
  const itemsPerPage = 10;
  const [search, setSearch] = useState("");
  const [sortField, setSortField] = useState<string>("createdAt");
  const [sortOrder, setSortOrder] = useState<"asc" | "desc">("desc");
  const [uiSortField, setUiSortField] = useState<string>("createdAtFormatted");
  const [loading, setLoading] = useState<boolean>(false);
  const [pagePermission, setPagePermission] = useState({
    canView: false,
    canAdd: false,
    canEdit: false,
    canDelete: false,
  });
  const sortFieldMap: Record<string, string> = {
    createdAtFormatted: "createdAt",
    email: "email",
    userName: "userName",
    userCompany: "userCompany",
    location: "location",
  };
  const [userObject, setUserObject] = useState<AddCommentInterface | null>(null);
  const userInfo = JSON.parse(localStorage.getItem("UserData") || "{}");
  //   const [pagePermission, setPagePermission] = useState({
  //     canView: false,
  //     canAdd: false,
  //     canEdit: false,
  //     canDelete: false,
  //   });

  useEffect(() => {
    getBannerList();
  }, [currentPage, sortField, sortOrder]);

  const getBannerList = (keyword: string = "") => {
    setLoading(true);
    const params = new URLSearchParams();
    params.append("page", currentPage.toString());
    params.append("limit", itemsPerPage.toString());

    // Keyword search
    if (keyword.trim()) {
      params.append("keyword", keyword.trim());
    }

    // Sorting
    params.append("sortField", sortField);
    params.append("sortOrder", sortOrder);

    WebService.getAPI({
      action: `email-subscriber/subscribers-list?${params.toString()}`,
    })
      .then((res: any) => {
        const perm = res?.data?.permissions || {};
        setPagePermission({
          canView: perm.canView,
          canAdd: perm.canAdd,
          canEdit: perm.canEdit,
          canDelete: perm.canDelete,
        });
        const formattedRows = res?.data?.data.map((item: any) => {
          return {
            ...item,

            email: item.email || "-",
      
            // phone: item.phone || "-",
            // createdAt: HelperService.getFormatedDate(item.createdAt),
            createdAt: item.createdAtFormatted, // formatting on backend side
          };
        });
        setLeadershipCouncils(formattedRows);
        setTotalCount(res?.data?.pagination?.total);
      })
      .catch((err: any) => {
        console.error("Error fetching admin :", err);
      })
      .finally(() => {
        setLoading(false);
      });
  };
    const handleExport = () => {
    WebService.getAPI({
      action: `email-subscriber/export-subscribers`,
    })
      .then((res: any) => {
        const blob = new Blob([res], {
          type: "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet",
        });

        const url = window.URL.createObjectURL(blob);
        const a = document.createElement("a");
        a.href = url;
        a.download = "subscribers_export.csv";
        document.body.appendChild(a);
        a.click();
        a.remove();

        toast.success("Exported successfully!");
      })
      .catch(() => {
        toast.error("Failed to export!");
      });
  };
  return (
    <>
     
    
      <div className="events-main">
        <Card className="event-card">
          <div className="d-flex justify-content-between">
            <div className="page-title">Email Subscribers</div>

            {pagePermission.canView && (
            <CustomButton
              isLoading={false}
              label="Export"
              onClick={handleExport}
              style={{ width: 100 }}
            />
            )}
          </div>
          <div className="row">
            <div className="col-md-3">
              <Form.Label className="label">Search</Form.Label>
              <Form.Control
                type="text"
                placeholder="Enter email"
                value={search}
                onChange={(e) => {
                  setSearch(e.target.value);
                  setCurrentPage(1);
                  getBannerList(e.target.value);
                }}
              />
            </div>
          </div>
          <CustomTableSortable
            columns={columns}
            rows={leadershipCouncils}
            totalCount={totalCount}
            currentPage={currentPage}
            pageSize={itemsPerPage}
            onPageChange={(page) => {
              setCurrentPage(page);
            }}
            isLoading={loading}
            sortField={uiSortField}
            sortOrder={sortOrder}
            onSortChange={(columnId, order) => {
              setUiSortField(columnId);
              setSortOrder(order);
              const apiField = sortFieldMap[columnId] || "createdAt";
              setSortField(apiField);
              setCurrentPage(1);
              // Fetch is driven by the useEffect (now depends on sortField/sortOrder) using fresh state.
            }}
          />
        </Card>
      </div>
    </>
  );
};

export default AdminUser;
